/** Conversion des champs numériques saisis (nombre, chaîne de formulaire, vide).
    Strictement équivalent à parseFloat, qui convertit déjà toute valeur en chaîne : seule la
    signature change, pour que le typage accepte les champs `Numerique`. */
export const toNumber = (valeur: unknown): number => parseFloat(valeur as string);
